import React from 'react';
import PropTypes from 'prop-types';

import RoundSectionTeaser from './RoundSectionTeaser';

import './FourColumnsBlock.module.css';

FourColumnsBlock.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  })),
};

FourColumnsBlock.defaultProps = {
  data: null,
};

function FourColumnsBlock({ data }) {
  return (
    <section styleName="FourColumnsBlock">
      <ul>
        {
          data.map((item) => (
            <li><RoundSectionTeaser data={item} /></li>
          ))
        }
      </ul>
    </section>
  );
}

export default FourColumnsBlock;



// WEBPACK FOOTER //
// ./src/components/FourColumnsBlock/FourColumnsBlock.js